import { useQuery } from '@tanstack/react-query';
import { projectEndUsersApi } from '../services/projectEndUsersApi';

export const projectEndUsersKeys = {
  all: ['projectEndUsers'] as const,
  list: (projectId: string) => [...projectEndUsersKeys.all, 'list', projectId] as const,
};

export function useProjectEndUsers(projectId: string | undefined) {
  return useQuery({
    queryKey: projectEndUsersKeys.list(projectId!),
    queryFn: async () => {
      const response = await projectEndUsersApi.list(projectId!);
      if (!response.success) {
        throw new Error(response.error || 'Failed to fetch end users');
      }
      return response.data;
    },
    enabled: !!projectId,
  });
}
